export default __webpack_public_path__ + "static/media/dress.91f7bcdc.png";